import(/* webpackMode: "eager", webpackExports: ["LoginForm"] */ "/vercel/path0/app/(auth)/login/login-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
